export const authRole = {
  admin: ['admin', 'superadmin'],
  user: ['user', 'admin', 'provider', 'superadmin', 'portal_user'],
};

export const RoutePermittedRole = {
  admin: ['admin', 'superadmin'],
  user: ['user', 'admin', 'provider', 'superadmin', 'portal_user'],
  provider: ['provider'],
  superadmin: ['superadmin'],
};
export const defaultUser = {
  full_name: 'John Alex',
  email: 'demo@example.com',
  token: 'access-token',
  role: 'admin',
  photoURL: '/assets/images/avatar/A11.jpg',
};
export const initialUrl = '/home'; // this url will open after login
